(ns nosco.ui.pills
  (:require
   ["react" :as React]
   [hx.hooks :as hooks]
   [hx.react :refer [defnc]]
   [nosco.colors :as colors]
   [nosco.icons2 :as icons]
   [nosco.react :as nosco-react]
   [nosco.ui.text :as text]))

(def ^:private loading-icon-size
  {:condensed {:width ".75rem" :height ".75rem"}
   :default {:width "1rem" :height "1rem"}
   :large {:width "1rem" :height "1rem"}})

(defnc RectangularPill [{:keys [color label]}]
  [:div {:class "nosco-pill-rectangular"}
   [:div {:style {:width "8px" :height "8px"
                  :border-radius "999px"
                  :background-color (get {:warning colors/warning-500
                                          :error colors/error-500
                                          :success colors/success-400} color)}}]
   [text/Text {:variant text/Body-Md-Bold}
    label]])

(defnc Counter [{:keys [label size clickable selected on-click class style inert]}]
  (let [size (or size :default)
        inert (if (some? inert) inert (not clickable))
        el (if clickable :button :span)]
    [el
     (cond-> {:class ["nosco-counter"
                      (when (= :small size) "nosco-counter--size-small")
                      (when (= :large size) "nosco-counter--size-large")
                      (when clickable "nosco-counter--clickable")
                      (when selected "nosco-counter--selected")
                      (when inert "nosco-counter--inert")
                      class]
              :style style}
       clickable (assoc :type "button")
       on-click (assoc :on-click on-click))
     label]))

(defnc Pill [{:keys [size color icon label dropdown removable on-remove on-click border title style loading]} ref]
  {:wrap [(React/forwardRef)]}
  (let [size (or size :default)
        color (or color :default)
        [remove-hover ->remove-hover] (hooks/useState false)]
    [:span
     (cond-> {:ref ref
              :style style
              :class ["nosco-pill"

                      (when border "nosco-pill--has-border")
                      (when (or icon loading) "nosco-pill--has-icon")
                      (when (or label loading) "nosco-pill--has-label")
                      (when loading "nosco-pill--loading")

                      (when removable "nosco-pill--removable")
                      (when remove-hover "nosco-pill--remove-hover")

                      (when on-click "nosco-pill--clickable")

                      (when (= :condensed size) "nosco-pill--size-condensed")
                      (when (= :large size) "nosco-pill--size-large")

                      (when (= :success color) "nosco-pill--color-success")
                      (when (= :warning color) "nosco-pill--color-warning")
                      (when (= :error color) "nosco-pill--color-error")
                      (when (= :info color) "nosco-pill--color-info")
                      (when (= :blue color) "nosco-pill--color-blue")]}
       title (assoc :title title)
       on-click (assoc :on-click on-click))
     (cond
       loading
       [icons/LoadingIcon {:color colors/neutral-500
                           :class "nosco-animation-loading-rotate-360"
                           :style (get loading-icon-size size)}]
       icon
       [icons/Icon
        {:icon icon
         :icon-style {:width (when (= :condensed size) ".75rem")}}])
     (when (and label (not loading))
       [:span {:class ["nosco-pill__label" "text-truncate"]}
        label])
     (cond
       dropdown
       [icons/Icon
        {:icon icons/DropdownSm-small
         :icon-style {:width (when (= :condensed size) ".75rem")}}]

       removable
       [:span
        {:class ["nosco-pill__remove"]
         :on-mouse-enter #(->remove-hover true)
         :on-mouse-leave #(->remove-hover false)
         :on-click
         (fn [event]
           (.stopPropagation event)
           (when on-remove
             (on-remove)))}
        [icons/Icon
         {:icon icons/CloseSmall-xsmall
          :icon-style {:width ".75rem"}}]])]))

(defnc PillButton [{:keys [size color icon label dropdown removable on-remove border] :as props} ref]
  [:button
   (-> {:class ["nosco-button-reset"]
        :ref ref}
       (nosco-react/merge-props (dissoc props :size :color :icon :label :dropdown :removable :on-remove :border)))
   [Pill
    {:size size
     :color color
     :icon icon
     :label label
     :dropdown dropdown
     :removable removable
     :on-remove on-remove
     :border border}]])

(nosco-react/forward-ref! PillButton)

(defnc PillLink [{:keys [size color icon label dropdown removable on-remove border] :as props} ref]
  {:wrap [(React/forwardRef)]}
  [:a
   (-> {:class ["nosco-link-button-reset"]
        :ref ref}
       (nosco-react/merge-props (dissoc props :size :color :icon :label :dropdown :removable :on-remove :border)))
   [Pill
    {:size size
     :color color
     :icon icon
     :label label
     :dropdown dropdown
     :removable removable
     :on-remove on-remove
     :border border}]])
